<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: ImageLibrary - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal" id="image_library">
    <div class="mt-6 flex items-center justify-between px-6" >
        <span class="flex items-center justify-center">
        <h4>SETTINGS</h4>
        </span>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

            <div class="p-6">
                <label for="" class="vs-select--label">Current Week</label>
                <vs-select
                    class="mb-base w-full"
                    placeholder="Select Week"
                    label-laceholder="Current Week"
                    autocomplete
                    v-model="setWeek">
                    <vs-select-item :key="index" :value="week.id" :text="week.week" v-for="week,index in weeks" />
                </vs-select>
                <span class="flex justify-between mb-base">
                <label>Rotate Menu</label>
                 <vs-switch v-model="isRotate"></vs-switch>
                 </span>
            </div>
    </component>
    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid">Save</vs-button>
      <vs-button type="border" color="danger" @click.native="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import {
    GET_FOOD_MENU_SETTING,
    GET_ALL_MENU_WEEKS,
    SET_FOOD_MENU_SETTING
} from '@/graphql'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    }
  },
  components: {
    VuePerfectScrollbar,
 

  },
  data () {
    return {
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      weeks:[],
      setWeek:null,
      isRotate:true,
    }
  },
  watch: {
    isSidebarActive (val) {
      if(val){
          this.getMenuSetting(this.$route.params.siteName)
          this.getAllWeeks(this.$route.params.siteName)
      }
    },
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSettingSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.setWeek
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
     getMenuSetting(site){
      this.$apollo
        .mutate({
          mutation: GET_FOOD_MENU_SETTING,
          variables: {
            site:site
          }
        })
        .then(response => {
          this.isRotate=response.data.getFoodMenuSetting.rotate
          this.setWeek=response.data.getFoodMenuSetting.week
        }).catch(error => {
          console.log(error)
        })
     },
    getAllWeeks(site){
     this.$apollo
        .mutate({
          mutation: GET_ALL_MENU_WEEKS,
          variables: {
            site: site,
          },
        })
        .then((response) => {
          let data = response.data.getAllMenuWeeks
          if(data.length>0){
          this.weeks =[]
          data.forEach(element => {
           element['week'] = 'Week '+element.name
         });
         this.weeks = data
         }
        })
        .catch((error) => {
          console.log(error);
        });
    },
      submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
         this.$apollo
        .mutate({
          mutation: SET_FOOD_MENU_SETTING,
          variables: {
            site:this.$route.params.siteName,
            rotate:this.isRotate,
            week:this.setWeek
          }
        })
        .then(response => {
          console.log(response)
          this.$emit('closeSettingSidebar')
        }).catch(error => {
          console.log(error)
        })
        }
      })
    },
  },
   

}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }

}
</style>
